import { maxLengthMessage, requiredMessage } from "../validationMessages";

import { trimmedString } from "./trimmedString";

const MAX_LENGTH = 60;

export const companyNameValidator = trimmedString.max(
  MAX_LENGTH,
  maxLengthMessage(MAX_LENGTH)
);
export const companyNameValidatorRequired = trimmedString
  .max(MAX_LENGTH, maxLengthMessage(MAX_LENGTH))
  .required(requiredMessage);
